var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blogSingle page"},[_c('div',{staticClass:"blogSingle__inner"},[_c('div',{staticClass:"blogSingle__breadcrumbs container"},[_c('breadcrumbs',{staticClass:"searchTemplate__breadcrumbs",attrs:{"list":[
          {
            url: '/',
            title: 'Ofix',
          },
          {
            to: _vm.localePath({ name: 'blog' }),
            title: 'Artykuły i porady',
          },
          {
            title: _vm.article.title,
          },
        ]}})],1),_vm._v(" "),_c('div',{staticClass:"blogSingle__header"},[_c('BlogHeader',{attrs:{"author":_vm.article.author,"date":_vm.article.updatedAt ? _vm.article.updatedAt : _vm.article.createdAt,"image":_vm.article.image,"title":_vm.article.title}}),_vm._v(" "),_c('div',{staticClass:"blogSingle__tableOfContents"},[_c('BlogTableOfContents',{attrs:{"list":_vm.tableOfContents}})],1)],1),_vm._v(" "),_c('div',{staticClass:"blogSingle__content"},[_c('BlogSections',{attrs:{"sections":_vm.article.contentJson.blocks}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }